// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const SHOPIER_COPY = {
	sectionTitle: msg({
		message: 'Buy Pro',
		context: 'premium-shopier',
		comment: 'Title of the Shopier one-time purchase block on the premium page.',
	}),
	sectionSubtitle: msg({
		message:
			'Pay once with a Turkish card. Each purchase adds time to your {premiumProductName} membership and nothing renews automatically.',
		context: 'premium-shopier',
		comment: 'Subtitle of the Shopier purchase block. premiumProductName is the premium product name.',
	}),
	monthlyTitle: msg({
		message: '1 month',
		context: 'premium-shopier',
		comment: 'Shopier plan card title for one month of premium.',
	}),
	yearlyTitle: msg({
		message: '1 year',
		context: 'premium-shopier',
		comment: 'Shopier plan card title for one year of premium.',
	}),
	priceOnShopier: msg({
		message: 'Price shown at checkout',
		context: 'premium-shopier',
		comment: 'Shown instead of a price when the price could not be verified.',
	}),
	getCode: msg({
		message: 'Get payment code',
		context: 'premium-shopier',
		comment: 'Button on a Shopier plan card that creates a personal payment code.',
	}),
	stepsTitle: msg({
		message: 'Complete your payment',
		context: 'premium-shopier',
		comment: 'Heading above the Shopier payment steps.',
	}),
	step1: msg({
		message: 'Copy your personal payment code.',
		context: 'premium-shopier',
		comment: 'Shopier payment step 1.',
	}),
	step2: msg({
		message: 'Paste the code into the order note field on the payment page.',
		context: 'premium-shopier',
		comment: 'Shopier payment step 2.',
	}),
	step3: msg({
		message: 'Finish the payment. {premiumProductName} turns on once the payment is verified.',
		context: 'premium-shopier',
		comment: 'Shopier payment step 3. premiumProductName is the premium product name.',
	}),
	codeLabel: msg({
		message: 'Your payment code',
		context: 'premium-shopier',
		comment: 'Label above the Shopier payment reference code.',
	}),
	copyCode: msg({
		message: 'Copy code',
		context: 'premium-shopier',
		comment: 'Button that copies the Shopier payment code.',
	}),
	openShopier: msg({
		message: 'Go to payment page',
		context: 'premium-shopier',
		comment: 'Button that opens the Shopier product page.',
	}),
	codeWarning: msg({
		message:
			'Without this code in the order note the payment cannot be matched to your account automatically and has to be reviewed by our team.',
		context: 'premium-shopier',
		comment: 'Warning under the Shopier payment code.',
	}),
	historyTitle: msg({
		message: 'Your purchases',
		context: 'premium-shopier',
		comment: "Heading of the user's own Shopier purchase list.",
	}),
	statusPending: msg({
		message: 'Waiting for payment',
		context: 'premium-shopier',
		comment: 'Shopier purchase status: no verified payment yet.',
	}),
	statusGranted: msg({
		message: '{premiumProductName} activated',
		context: 'premium-shopier',
		comment: 'Shopier purchase status: premium granted.',
	}),
	statusReview: msg({
		message: 'Needs review',
		context: 'premium-shopier',
		comment: 'Shopier purchase status: held for staff review.',
	}),
	statusRefunded: msg({
		message: 'Refunded',
		context: 'premium-shopier',
		comment: 'Shopier purchase status: refunded.',
	}),
	reviewHelp: msg({
		message: 'Our team will check this payment. You do not need to pay again.',
		context: 'premium-shopier',
		comment: 'Help text for a Shopier purchase under review.',
	}),
	pendingHelp: msg({
		message: 'Already paid? It can take a few minutes to show up here.',
		context: 'premium-shopier',
		comment: 'Help text for a pending Shopier purchase.',
	}),
	refresh: msg({
		message: 'Refresh',
		context: 'premium-shopier',
		comment: 'Button that reloads the Shopier purchase list.',
	}),
	createFailed: msg({
		message: 'Could not create a payment code. Please try again.',
		context: 'premium-shopier',
		comment: 'Error toast when creating a Shopier payment code fails.',
	}),
	navHome: msg({
		message: 'Home',
		context: 'premium-shopier',
		comment: 'Premium page top navigation: scroll to the top.',
	}),
	navPlans: msg({
		message: 'Plans',
		context: 'premium-shopier',
		comment: 'Premium page top navigation: scroll to plans.',
	}),
	navCompare: msg({
		message: 'Compare',
		context: 'premium-shopier',
		comment: 'Premium page top navigation: scroll to the comparison table.',
	}),
	plansHeading: msg({
		message: 'Choose your plan',
		context: 'premium-shopier',
		comment: 'Heading of the Shopier plan cards.',
	}),
	plansSubheading: msg({
		message: 'Secure card payment. One-time payment, nothing to cancel later.',
		context: 'premium-shopier',
		comment: 'Subheading of the Shopier plan cards.',
	}),
	perMonth: msg({
		message: '/ month',
		context: 'premium-shopier',
		comment: 'Suffix after the monthly price.',
	}),
	perYear: msg({
		message: '/ year',
		context: 'premium-shopier',
		comment: 'Suffix after the yearly price.',
	}),
	monthlyEquivalent: msg({
		message: 'Only {price} per month',
		context: 'premium-shopier',
		comment: 'Yearly plan: equivalent monthly price.',
	}),
	bestValue: msg({
		message: 'Best value',
		context: 'premium-shopier',
		comment: 'Badge on the yearly plan card.',
	}),
	savePercent: msg({
		message: 'Save {percent}%',
		context: 'premium-shopier',
		comment: 'Badge showing the yearly discount percentage.',
	}),
	featureAllPerks: msg({
		message: 'All {premiumProductName} perks',
		context: 'premium-shopier',
		comment: 'Plan card bullet.',
	}),
	featureNoRenewal: msg({
		message: 'One-time payment, no auto-renewal',
		context: 'premium-shopier',
		comment: 'Plan card bullet.',
	}),
	featureStacks: msg({
		message: 'Adds time on top of an active plan',
		context: 'premium-shopier',
		comment: 'Plan card bullet.',
	}),
	subscribe: msg({
		message: 'Subscribe',
		context: 'premium-shopier',
		comment: 'Plan card button that starts the Shopier payment.',
	}),
	modalTitle: msg({
		message: 'Complete your payment',
		context: 'premium-shopier',
		comment: 'Title of the Shopier payment dialog.',
	}),
	modalPreparing: msg({
		message: 'Preparing your payment…',
		context: 'premium-shopier',
		comment: 'Shown while the payment code is being created.',
	}),
	modalCodeCopied: msg({
		message: 'Your payment code is copied. Paste it into the order note field on the payment page.',
		context: 'premium-shopier',
		comment: 'Shown after the payment code was copied automatically.',
	}),
	modalCodeNotCopied: msg({
		message: 'Copy your payment code and paste it into the order note field on the payment page.',
		context: 'premium-shopier',
		comment: 'Shown when the payment code could not be copied automatically.',
	}),
	modalWaiting: msg({
		message: 'Waiting for your payment. This window updates automatically.',
		context: 'premium-shopier',
		comment: 'Payment dialog waiting state.',
	}),
	modalPopupClosed: msg({
		message: 'The payment window was closed. If you paid, confirmation can take a few minutes.',
		context: 'premium-shopier',
		comment: 'Payment dialog after the Shopier window closes.',
	}),
	modalPopupBlocked: msg({
		message: 'Your browser blocked the payment window.',
		context: 'premium-shopier',
		comment: 'Payment dialog when the popup was blocked.',
	}),
	modalOpenShopier: msg({
		message: 'Open payment window',
		context: 'premium-shopier',
		comment: 'Button that (re)opens the Shopier payment window.',
	}),
	modalSuccessTitle: msg({
		message: '{premiumProductName} is active!',
		context: 'premium-shopier',
		comment: 'Payment dialog success title.',
	}),
	modalSuccessBody: msg({
		message: 'Thanks for your support. Your perks are ready to use.',
		context: 'premium-shopier',
		comment: 'Payment dialog success text.',
	}),
	modalClose: msg({
		message: 'Close',
		context: 'premium-shopier',
		comment: 'Close button of the payment dialog.',
	}),
	navPurchases: msg({
		message: 'My purchases',
		context: 'premium-shopier',
		comment: 'Premium page top navigation: open the purchase history view.',
	}),
	purchasesEmpty: msg({
		message: 'You have no purchases yet.',
		context: 'premium-shopier',
		comment: 'Empty state of the Shopier purchase history.',
	}),
	pendingExpiryHelp: msg({
		message:
			'Already paid? Confirmation can take a few minutes. If no payment arrives within 30 minutes, this entry is removed.',
		context: 'premium-shopier',
		comment: 'Help text under a pending Shopier purchase.',
	}),
	addTime: msg({
		message: 'Add time',
		context: 'premium-shopier',
		comment: 'Button for active members to buy more premium time.',
	}),
	chooserTitle: msg({
		message: 'Add {premiumProductName} time',
		context: 'premium-shopier',
		comment: 'Title of the dialog where an active member picks how much time to add.',
	}),
	chooserBody: msg({
		message: 'Pick how much time to add. It is added on top of your current end date.',
		context: 'premium-shopier',
		comment: 'Body of the add-time dialog.',
	}),
	chooserContinue: msg({
		message: 'Continue to payment',
		context: 'premium-shopier',
		comment: 'Confirm button of the add-time dialog.',
	}),
	errorLifetime: msg({
		message: 'You already have lifetime {premiumProductName}, so there is no time to add.',
		context: 'premium-shopier',
		comment: 'Shown when a lifetime member tries to buy time.',
	}),
	errorPurchaseDisabled: msg({
		message: 'Purchases are turned off for this account. Please contact support.',
		context: 'premium-shopier',
		comment: 'Shown when purchases are disabled for the account.',
	}),
	errorVerifyEmail: msg({
		message: 'Verify your email address before buying.',
		context: 'premium-shopier',
		comment: 'Shown when the account email is not verified.',
	}),
	errorClaimAccount: msg({
		message: 'Finish setting up your account before buying.',
		context: 'premium-shopier',
		comment: 'Shown when an unclaimed account tries to buy.',
	}),
	errorUnavailable: msg({
		message: 'Payments are temporarily unavailable. Please try again later.',
		context: 'premium-shopier',
		comment: 'Shown when payments are not configured or temporarily disabled.',
	}),
	lifetimeMember: msg({
		message: 'Lifetime member',
		context: 'premium-shopier',
		comment: 'Disabled plan button label for lifetime members.',
	}),
	errorAlreadyOwned: msg({
		message: 'You already own this item.',
		context: 'premium-shopier',
		comment: 'Shown when buying an item the user already owns.',
	}),
	proceedToPayment: msg({
		message: 'Continue to payment',
		context: 'premium-shopier',
		comment: 'Payment dialog button that copies the code and opens the payment page.',
	}),
	modalReadyHint: msg({
		message: 'Paste this code into the order note field on the payment page. It is copied for you when you continue.',
		context: 'premium-shopier',
		comment: 'Payment dialog text shown before the payment page opens.',
	}),
	statusItemGranted: msg({
		message: 'Added to your account',
		context: 'premium-shopier',
		comment: 'Store purchase status: item granted.',
	}),
	giftTitle: msg({
		message: 'Have a gift code?',
		context: 'premium-shopier',
		comment: 'Heading of the gift code box on the premium page.',
	}),
	giftPlaceholder: msg({
		message: 'Enter your gift code',
		context: 'premium-shopier',
		comment: 'Placeholder of the gift code input.',
	}),
	giftRedeem: msg({
		message: 'Redeem',
		context: 'premium-shopier',
		comment: 'Button that redeems a gift code.',
	}),
} as const;
